module.exports = require("./ru-MD.js");